import { ArrayData as AdminClientRoutes, ArrayData } from "../../navigation/routes/AdminClientRoutes";
import { setSelectedAccountantName, setSelectedHomePage } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";

import { ArrayData as AccountantListRoutes } from "../../navigation/routes/AccountantListRoutes";
import { AccountantService } from "../../services";
import { ArrayData as AdminAccountantRoutes } from "../../navigation/routes/AdminAccountantRoutes";
import { ArrayData as AdminRoutes } from "../../navigation/routes/AdminRoutes";
import { ArrayData as ClientListRoutes } from "../../navigation/routes/ClientListRoutes";
import { ArrayData as ClientListRoutesWithAcc } from "../../navigation/routes/ClientListRoutesWithAcc";
import { ArrayData as ClientRoutes } from "../../navigation/routes/ClientRoutes";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { LeftMenu } from "../LeftMenu";
import { homePageReducer } from "../../store/reducers/homePageReducers";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

const useAccountants = (params: IGetListRequest, isAdminUser: number, selectedAccountantId: string) =>
  useQuery({
    queryKey: ["accountants-list", params, isAdminUser, selectedAccountantId],
    queryFn: (data) => {
      return AccountantService.getAccountantsToManageNavBar(params, isAdminUser, selectedAccountantId);
    },
    refetchOnWindowFocus: false
  }
  );


export const RoleBasedLeftMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAdminUser = useSelector(
    (state: IAppState) => state.user.profile.isSuperStatus
  );

  const selectedAccountantId = useSelector(
    (state: IAppState) => state.accountant.id
  );

  const selectedAccountantName = useSelector(
    (state: IAppState) => state.accountant.AccountantName
  );

  const selectedClientId = useSelector(
    (state: IAppState) => state.client.id
  );

  const selectedClientName = useSelector(
    (state: IAppState) => state.client.clientName
  );

  const selectedYear = useSelector(
    (state: IAppState) => state.taxYear.year
  );

  const invoiceRefNo = useSelector(
    (state: IAppState) => state.invoice.refNo
  );

  const CSVInformationUI = useSelector(
    (state: IAppState) => state.CSVInformationUI
  );

  const HomePagePath = useSelector(
    (state: IAppState) => state.HomePagePath.path
  );

  const selectedMenuItem = useSelector(
    (state: IAppState) => state.navigation.selectedMenuItem
  );

  const drawerAction = useSelector(
    (state: IAppState) => state.drawerAction.open
  );

  const activityLog = useSelector(
    (state: IAppState) => state.activityLog
  );

  const isLoadAxiosCall = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );

  const stickyNavBar = useSelector(
    (state: IAppState) => state.stickyNavBar.isSticky
  );

  const dashboard = useSelector(
    (state: IAppState) => state.dashboardApisData
  );
  // console.log('t4summaryConfirmationcode', dashboard)
  const queryParams = useMemo(
    () => ({
      search_query: "",
      order_by: "accTitle",
      order_direction: "asc",
      page: 1,
      size: 25
    }),
    []
  );
  const { isLoading, data } = useAccountants(queryParams, isAdminUser, selectedAccountantId);
  const accountantList: any = data;
  const [menu, setMenu] = useState<any>(AdminRoutes);

  useEffect(() => {
    if (isAdminUser !== 0) {
      if (selectedClientId && selectedClientId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/clients/dashboard" }));

        setMenu(AdminClientRoutes);
      }
      else if (selectedAccountantId && selectedAccountantId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/accountants/clients" }));

        setMenu(AdminAccountantRoutes);
      }
      else {
        dispatch(setSelectedHomePage({ path: "/global-search" }));

        setMenu(AdminRoutes);
      }
    }
    else {
      // alert("Only Admin can Login So, Please provide Admin Username or Password!")
      // if (selectedClientId && selectedClientId.length > 0) {
      //   setMenu(ClientRoutes)
      // } else {
      //   setMenu(ClientListRoutes);
      // }
      // if (selectedAccountantId && selectedAccountantId.length > 0) {
      //   setMenu(ClientListRoutes);
      // }
      // else {
      //     setMenu(AccountantListRoutes);
      //   }
      if (selectedClientId && selectedClientId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/clients/dashboard" }));
        setMenu(ClientRoutes)
      }
      else if (selectedAccountantId && selectedAccountantId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/accountants/clients" }));

        // if(accountantList && accountantList.items && accountantList.items.length !== 0){

        //   setMenu(ClientListRoutesWithAcc);
        // } else {
        //   setMenu(ClientListRoutes);
        // }
        if (accountantList && accountantList.items && accountantList.items.length > 1) {

          setMenu(ClientListRoutesWithAcc);
        } else if (accountantList && accountantList.items && accountantList.items.length === 1) {
          setMenu(ClientListRoutes);
          dispatch(setSelectedAccountantName(accountantList.items[0]));
        } else {
          setMenu(ClientListRoutes);
        }
      }
      else {
        dispatch(setSelectedHomePage({ path: "/accountants" }));
        setMenu(AccountantListRoutes);
      }
    }

    // if (accountantList && accountantList.message && accountantList.message.detail === "Invalid token or expired token.") {
    //   let path = '/logout'
    //   navigate(path)
    // }
  }, [accountantList, selectedClientId, selectedAccountantId]);

  return <LeftMenu menuItems={menu} />;
};
